import React from "react";
import "./EarningsChart.css";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const EarningsChart = ({ analytics }) => {
  const chartData = months.map((month, index) => {
    const found = analytics.find(
      (item) => item._id.month === index + 1
    );

    return {
      month,
      earnings: found ? found.earnings : 0,
      orders: found ? found.orders : 0,
    };
  });

  return (
    <div className="earnings-chart">

      <div className="chart-header">
        <h2>Monthly Earnings</h2>
        <p>
          Earnings generated throughout the year
        </p>
      </div>

      <ResponsiveContainer
        width="100%"
        height={350}
      >
        <BarChart data={chartData}>

          <CartesianGrid strokeDasharray="3 3" />

          <XAxis dataKey="month" />

          <YAxis />

          <Tooltip />

          <Legend />

          <Bar
            dataKey="earnings"
            name="Earnings (₹)"
            radius={[8, 8, 0, 0]}
          />

        </BarChart>
      </ResponsiveContainer>

      <div className="chart-footer">

        <div>
          <span>Total Months</span>

          <strong>12</strong>
        </div>

        <div>
          <span>Highest Month</span>

          <strong>
            ₹
            {Math.max(
              ...chartData.map(
                (item) => item.earnings
              )
            ).toLocaleString()}
          </strong>
        </div>

      </div>

    </div>
  );
};

export default EarningsChart;